import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

import { computed, PropType, ref } from 'vue';

import { useGetTypeQuery } from '@/entities/type/hooks';
import { useGetDeviceGroupQuery } from '@/entities/device-group/hooks';
import { useGetDevicesQuery } from '@/entities/device/hooks';
import { usePaginatedResponse } from '@/utils/query';

import { resume } from '@/plugins/resume';

import { Type } from '@/entities/type/types';
import { DeviceGroup } from '@/entities/device-group/types';

import {
  NkEntry,
  NkGroup,
  NkButtonLink,
  NkInlineModal,
  NkButton,
  NkInputText,
} from '@/core/components';

import DeviceCreateForm from '@/entities/device/components/form/DeviceCreateForm.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceEntry',
  props: {
  type: {
    type: Number as PropType<Type['id']>,
    required: true,
  },
  deviceGroup: {
    type: Number as PropType<DeviceGroup['id']>,
    default: null,
  },
},
  setup(__props) {

const props = __props



const searchTerm = ref('');

const deviceGroupQueryData = computed(() => ({ id: props.deviceGroup }));
const hasDeviceGroupQueryData = computed(() => !!deviceGroupQueryData.value);
const { data: currentDeviceGroup } = useGetDeviceGroupQuery(deviceGroupQueryData, {
  enabled: hasDeviceGroupQueryData,
});

const typeQueryData = computed(() => ({ id: props.type }));
const hasTypesData = computed(() => !!typeQueryData.value.id);
const { data: type } = useGetTypeQuery(typeQueryData, { enabled: hasTypesData });

const devicesQueryFilters = computed(() => ({
  ids: currentDeviceGroup.value?.devices || [],
  typeId: props.type,
  itemsPerPage: currentDeviceGroup.value?.devices?.length || undefined,
  order_device: 'asc',
}));

const hasDevicesQueryFilters = computed(() => !!devicesQueryFilters.value?.ids.length);
const { data: devicesData, isLoading } = useGetDevicesQuery({
  enabled: hasDevicesQueryFilters,
  keepPreviousData: true,
}, devicesQueryFilters, {
  headers: {
    'Content-Type': 'application/vnd.api+json',
    'Accept': 'application/vnd.api+json',
  },
});
const { data: devices } = usePaginatedResponse(devicesData);

const getDevices = computed(() => devices.value?.map((o) => ({
  ...o,
  name: o.deviceValues.find(dv => dv.reference === 'name') || '-',
})) || []);

const sortedDevices = computed(() => [...getDevices.value].sort((left, right) =>
  String(left.name?.value || '').localeCompare(String(right.name?.value || ''), undefined, {
    numeric: true,
    sensitivity: 'base',
  })));

const filteredDevices = computed(() => {
  const normalizedSearchTerm = searchTerm.value.trim().toLocaleLowerCase();

  if (!normalizedSearchTerm) {
    return sortedDevices.value;
  }

  return sortedDevices.value.filter((device) =>
    String(device.name?.value || '').toLocaleLowerCase().includes(normalizedSearchTerm));
});

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return (_unref(type))
    ? (_openBlock(), _createBlock(_unref(NkEntry), {
        key: 0,
        title: _unref(type)?.name
      }, {
        actions: _withCtx(() => [
          _createVNode(_unref(NkInputText), {
            modelValue: searchTerm.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTerm).value = $event)),
            placeholder: _ctx.$t('misc.search'),
            class: "w-56"
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_unref(NkGroup), { spacing: 5 }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredDevices), (device) => {
                return (_openBlock(), _createBlock(_unref(NkButtonLink), {
                  title: device.name?.value,
                  to: {
          name: 'visionair-device',
          params: {
            device: device.id,
          }
        },
                  key: device.id
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(resume)(device.name?.value, 60)), 1)
                  ]),
                  _: 2
                }, 1032, ["title", "to"]))
              }), 128)),
              (_ctx.$store.getters['connection/isGranted'](['device_create']))
                ? (_openBlock(), _createBlock(_unref(NkInlineModal), {
                    key: 0,
                    title: _ctx.$t('device.action.add'),
                    class: "max-w-screen-md"
                  }, {
                    content: _withCtx(({close}) => [
                      _createVNode(DeviceCreateForm, {
                        "type-id": props.type,
                        "device-group": props.deviceGroup,
                        onSubmitted: close
                      }, null, 8, ["type-id", "device-group", "onSubmitted"])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(NkButton), {
                        circle: "",
                        size: "sm",
                        icon: "NkPlus",
                        class: "text-white"
                      })
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })), [
            [_directive_loading, _unref(isLoading)]
          ])
        ]),
        _: 1
      }, 8, ["title"]))
    : _createCommentVNode("", true)
}
}

})